import api from '../api';

const ROLE_LIST_SUCCESS = api.events.rolesList.actionSuccess;

const defaultState = { all: [] };

export default function preferences(state = defaultState, action) {
  switch (action.type) {
    case ROLE_LIST_SUCCESS:
      return { ...state, all: action.data };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/role.js